/* this file added by Bearer Web Developer  */
import React, { useContext } from 'react';
import styles from './time.module.scss';
import { ReservedOrderInfoContext } from '../contexts/reservedOrderInfo';
import { useThemeMode } from '../../../../../../states/contexts/theme';
import getTime from '../../../../../../app/getTime';


const Time: React.FC = () => {
    const reservedOrderDetails = useContext(ReservedOrderInfoContext);
    const creationTimeMiliseconds = Number(reservedOrderDetails?.transport_creation_time);
    const earliest_pickup_time = reservedOrderDetails?.earliest_pickup_time;
    const is_time_sensitive_order = reservedOrderDetails?.is_time_sensitive_order;
    const earliest = earliest_pickup_time && is_time_sensitive_order;
    const earliestTime = earliest ? getTime(earliest_pickup_time) : null;
    const date = new Date(creationTimeMiliseconds)?.toLocaleDateString();
    const time = getTime(creationTimeMiliseconds);
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <div className={styles.time_part} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            {
                earliest && earliestTime ?
                    <div className={styles.earliest_time}>
                        <div className={styles.line}></div>
                        <span className={styles.time}>{earliestTime}</span>
                    </div>
                    :
                    <>
                        <div className={styles.date}>
                            {
                                theme === 'dark' ? <img src="/calendar-month-white.svg" alt="" width={20} height={20} /> :
                                    <img src="/calendar-month-grey.webp" alt="" width={20} height={20} />
                            }
                            <span>{date}</span>
                        </div>
                        <div className={styles.time_value}>
                            {
                                theme === 'dark' ? <img src="/schedule-white.svg" alt="" width={20} height={20} /> :
                                    <img src="/schedule-grey.webp" alt="" width={20} height={20} />
                            }
                            <span>{time}</span>
                        </div>
                    </>
            }
        </div>
    )
}

export default Time;